{
    "comment_slider.response": "argument",
    "comment_slider.responses": "arguments",
    "editorial_question.lets_talk": "Proponi in'idea",
    "editorial_question.share_thoughts": "Cundividai Voss patratgs",
    "login.continue_with": "Cuntinuar cun login SRG",
    "question.input_placeholder": "Vossa idea:",
    "upvote.count": "Sustegnì {count}x"
}
